import { render, staticRenderFns } from "./mzj_Footer.vue?vue&type=template&id=f40e85dc&scoped=true&"
import script from "./mzj_Footer.vue?vue&type=script&lang=js&"
export * from "./mzj_Footer.vue?vue&type=script&lang=js&"
import style0 from "./mzj_Footer.vue?vue&type=style&index=0&id=f40e85dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40e85dc",
  null
  
)

export default component.exports